import React from "react";
import Layout from "../components/Layout";
import imgslide1 from "../assets/images/cover1.jpeg";
import imgslide2 from "../assets/images/cover2.jpeg";
import img1 from "../assets/images/17.jpeg";
import img2 from "../assets/images/15.jpeg";

import "../assets/css/Homepage.scss";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

const Homepage = () => {
  return (
    <Layout>
      <div className="homepage_content">
        <div className="sections">
          <img src={imgslide1} alt="" />
          <h3>Lorem ipsum dolor</h3>
          <p>
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Pariatur
            sequi eum a atque autem! Ratione nemo assumenda similique
            voluptatem, soluta natus exercitationem reprehenderit voluptatum
            aspernatur excepturi! Eos architecto nulla recusandae.
          </p>
          <p>
            Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quasi,
            laudantium? Dolorum corporis est mollitia laborum! Officiis nobis
            reprehenderit quas sed commodi? Corporis qui inventore mollitia
            facilis, quod ea perspiciatis quisquam!
          </p>
        </div>
        <div className="section_content">
          <img src={img1} alt="" />
          <div className="content_text">
            <h3>Lorem ipsum dolor sit amet.</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Beatae
              tempore consequatur nesciunt atque praesentium totam quidem
              mollitia exercitationem enim dolor cumque doloremque aliquid,
              voluptate similique, voluptates possimus magni libero minus!
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque
              similique repudiandae quasi molestiae mollitia illo sapiente ut,
              quam fugiat tempore non accusamus dignissimos! Incidunt, laborum
              rerum? Maxime dignissimos necessitatibus quasi?
            </p>
          </div>
        </div>
        <div className="section_content">
          <div className="content_text">
            <h3>Lorem ipsum dolor sit amet.</h3>
            <p>
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Beatae
              tempore consequatur nesciunt atque praesentium totam quidem
              mollitia exercitationem enim dolor cumque doloremque aliquid,
              voluptate similique, voluptates possimus magni libero minus!
            </p>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque
              similique repudiandae quasi molestiae mollitia illo sapiente ut,
              quam fugiat tempore non accusamus dignissimos! Incidunt, laborum
              rerum? Maxime dignissimos necessitatibus quasi?
            </p>
          </div>
          <img src={img2} alt="" />
        </div>
        <div className="sections">
          <img src={imgslide2} alt="" />
          <h3>Lorem ipsum dolor sit amet.</h3>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora
            atque est facere consequatur ducimus distinctio aliquid molestiae
            cupiditate? Non quo ab quaerat a velit eos voluptas accusamus
            voluptatem tempore exercitationem.
          </p>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Eligendi
            alias, quasi quidem dolorum placeat natus, nulla fugit possimus
            laudantium suscipit incidunt ab, magni voluptates sequi. Quaerat
            exercitationem ipsa laudantium aspernatur?
          </p>
        </div>
        {/* <Swiper
        spaceBetween={30}
        centeredSlides={true}
        speed={2500}
        loop={true}
        // autoplay={{
        //   delay: 2500,
        //   disableOnInteraction: false,
        // }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src={imgslide1} />
        </SwiperSlide>
        <SwiperSlide>
          <img src={imgslide2} />
        </SwiperSlide>
      </Swiper> */}
      </div>
    </Layout>
  );
};

export default Homepage;
